var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreyLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 1,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F131B",
  strokeLinecap: "round",
  d: "M.5.5h23"
})));
export default SvgGreyLine;